// eslint-disable-next-line max-classes-per-file
export class InvalidCharacterError extends Error {
  name = 'InvalidCharacterError'
}

export class InvalidTokenError extends Error {
  name = 'InvalidTokenError'
}
